

<template>
  <!-- 定义布局容器 -->
  <el-container class="home-container">
    <!-- 定义头标签 -->
    <el-header class="top-header">
      <div class="brand-area">
        <img class="headerlogo"
          src="https://benda-motor-resource.oss-cn-hangzhou.aliyuncs.com/website/assets/assets/logo_2.png"
          @click="gotoStart" />
      </div>
      <headaa ref="headd"></headaa>

      <!-- <div>
        <img class="headerlogo"
          src="https://benda-motor-resource.oss-cn-hangzhou.aliyuncs.com/website/assets/assets/logo_2.png" />
      </div>
      <div class="headertab">
        <div class="mr-120" @click="tabclick(item, index)" v-for="(item, index) in menuList" :key="index"
          style="position: relative; z-index: 99;width: 100px;">
          <div @mouseenter="setStyle(index)" @mouseleave="delStyle()">
            {{ item.name }}
          </div>


          <div class="menu-tab" v-show="index == show">
            <p class="menu-item" @click.stop="gotoCart(1)">周边品采购</p>
            <p class="menu-item" @click.stop="gotoCart(2)">配件采购</p>
            <p class="menu-item" @click.stop="gotoCart(3)">购物车</p>
          </div>
        </div>

      </div>

      <div>
        <el-dropdown @command="routera">
          <span class="el-dropdown-link" style="font-size: 20px;cursor: pointer;">
            {{ name }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="/my">账号中心</el-dropdown-item>
            <el-dropdown-item command="/employee"> 员工管理</el-dropdown-item>
            <el-dropdown-item command="/login"> 退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div> -->
      <div class="header-actions">
        <div class="quick-actions">
          <img class="quick-action-icon" v-if="yj==0&&tup=='2'" @click="ycl(1)" src="../../assets/images/zyl.png" alt="">
          <img class="quick-action-icon" v-if="yj==1&&tup=='2'" @click="ycl(0)" src="../../assets/images/byl.png" alt="">
          <img class="quick-action-icon" v-if="tup=='2'" @click="goPush('/cart', $t('menu.ShoppingCart'))" src="../../assets/images/gwclog.png" alt="">
          <img class="quick-action-icon" v-else @click="goPush('/carta', $t('menu.ShoppingCart'))" src="../../assets/images/gwclog.png" alt="">
          <div class="notice-action" @click="goPush('/public', $t('menu.Bulletin'))">
            <i class="el-icon-bell"></i>
            <span v-if="totale>0" class="notice-badge">{{ totale > 99 ? '99+' : totale }}</span>
          </div>
        </div>

        <el-dropdown @command="routera" class="language-dropdown">
          <span class="el-dropdown-link language-trigger">
              <span v-if="i18nac=='zh'">ZH</span>
              <span v-if="i18nac=='en'">EN</span>
              <span v-if="i18nac=='de'">DE</span>
            
            <i class="el-icon-arrow-down el-icon--right" style="font-size: 10px;"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
           <el-dropdown-item v-if="i18nac!=='zh'" @click.native="tabCn">Chinese > </el-dropdown-item>
            <el-dropdown-item v-if="i18nac!=='en'" @click.native="tabEn">English ></el-dropdown-item>
            <el-dropdown-item v-if="i18nac!=='de'" @click.native="tabde">Deutsch ></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <el-dropdown @command="routera" class="user-dropdown">
          <span class="el-dropdown-link user-trigger">
            <span class="user-name">{{ name }}</span>
            <span class="user-avatar">{{ userInitial }}</span>
            <i class="el-icon-arrow-down user-arrow"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="goPush('/my', $t('menu.AccountCenter'))">{{ $t('menu.AccountCenter')
              }}</el-dropdown-item>
            <el-dropdown-item v-if="array.indexOf('User-outer') >= 0"
              @click.native="goPush('/employee', $t('menu.EmployeeManagement'))">{{
                $t('menu.EmployeeManagement')
              }}</el-dropdown-item>
            <!-- <el-dropdown-item v-if="lange" @click.native="tabCn">Chinese > </el-dropdown-item>
            <el-dropdown-item v-else @click.native="tabEn">English ></el-dropdown-item> -->
            <!-- 德国 endamoto.com-->
            <!-- <el-dropdown-item v-else @click.native="tabEn">Deutsch ></el-dropdown-item> -->
            <el-dropdown-item command="logout">{{ $t('menu.LogOff') }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>

    <!-- 定义中间区域-->
    <el-container>
      <!-- 定义主页面结构-->
      <el-main :class="{ 'sales-page-main': $route.path === '/Sales', 'single-scroll-main': $route.path === '/orderDetailsa' }" style="background-color: #fff;">
        <div v-if="$route.path !== '/Sales'" class="breadcrumb">
          <!-- <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: breadcrumbpath }">{{breadcrumb1}}</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: breadcrumbpath }">{{breadcrumb2 }}</el-breadcrumb-item>
          </el-breadcrumb> -->
          <!-- {{ breadcrumb2 }} -->
          <div v-if="titleName == '订单详情' || titleName == '修改订单' || titleName == '重新申请'|| titleName == '销售注册详情'|| titleName == 'Details' "
            style="display: flex;align-items: center; cursor: pointer;">
            <i class="el-icon-arrow-left ccba" style="" @click="goBack"></i>
          </div>
          <div v-if="titleName!=='首页'&&titleName!=='home'&&titleName!==null">{{ titleName }}</div>
        </div>
        <!-- 定义路由展现页面-->
           <keep-alive>
              <router-view  v-if="$route.meta.keepAlive"  :key="$route.fullPath" @topnum="topnum"  class="viewcontent"></router-view>
           </keep-alive>
   
  <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"  @topnum="topnum"  class="viewcontent" ></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { noticetList } from '../../api/api'
import headaa from '../../components/head'
export default {
  components: {
    headaa
  },
  data () {
    return {
      titleName: '',
      showMenu: false,
      show: 0,
      breadcrumbpath: '',
      name: '',
      i18nac:'zn',
      breadcrumb1: '销售',
      breadcrumb2: '配件采购',
      lange: false,
      array: [],
      tup:'1',
      totale:0,
      actio: '',
      //左侧菜单数据
      menuList: [
        // {
        //   id:1,
        //   name:'销售注册',
        //   valea: '',
        //   path:'/sell',
        // },
        {
          id: 2,
          name: '备件采购',
          valea: '',
          path: '/shop',
        },
        {
          id: 3,
          name: '订单查询',
          valea: '',
          path: '/order',
        },
        // {
        //   id:4,
        //   name:'售后索赔',
        //   valea: '',
        //   path:'/sale',
        // },
        {
          id: 5,
          name: '账户中心',
          valea: '',
          path: '/account',
        },
        {
          id: 6,
          name: this.$t('menu.DocumentCenter'),
          valea: '',
          path: '/documents',
        },
        {
          id: 7,
          name: this.$t('menu.Bulletin'),
          valea: '',
          path: '/public',
        },
        //   {id:1,
        //   name:'装配方案',
        //   valea: '',
        //   children:[
        //       {
        //         valea: '',
        //     id:3,
        //     path:'/zx',
        //     name:'装配方案'
        //   },
        //    {
        //         valea: '',
        //     id:6,
        //     path:'/user',
        //     name:'项目列表'
        //   },
        //    {
        //         valea: '',
        //     id:12,
        //     path:'/price',
        //     name:'价格维护'
        //   },
        //   {
        //         valea: '',
        //     id:14,
        //     path:'/record',
        //     name:'维护记录'
        //   },
        //   ]
        //   },
        //    {id:18,
        //   name:'新闻设置',
        //   valea: '',
        //   children:[
        //       {
        //         valea: '',
        //     id:5,
        //     path:'/news',
        //     name:'新闻列表'
        //   },
        //   ]
        //   },
        // {id:8,
        //   name:'系统设置',
        //   valea: '',
        //   children:[
        //       {
        //         valea: '',
        //     id:9,
        //     path:'/usera',
        //     name:'管理员设置'
        //   },
        //      {
        //         valea: '',
        //     id:10,
        //     path:'/role',
        //     name:'角色设置'
        //   },
        //     {
        //         valea: '',
        //     id:11,
        //     path:'/my',
        //     name:'个人设置'
        //   },
        //   ]
        //   },
        //   {id:16,
        //   name:'供需信息',
        //   valea: '',
        //   children:[
        //       {
        //         valea: '',
        //     id:15,
        //     path:'/information',
        //     name:'信息列表'
        //   }
        //   ]
        //   },
      ],
      yj:0,
    }
  },
  created () {
    let aa = sessionStorage.getItem('i18n')
    this.i18nac=sessionStorage.getItem('i18n')
    if (aa == 'zh') {
      this.lange = false
      this.$i18n.locale = 'zh'
    }else if (aa == 'en'){
      this.lange = true
      this.$i18n.locale = 'en'
    }
    else {
      this.lange = true
      this.$i18n.locale = 'de'
    }
    let Button = JSON.parse(sessionStorage.getItem('Button'))
    let nume = JSON.parse(sessionStorage.getItem('menu'))
    this.tup=sessionStorage.getItem('platform')
    this.array = Button
    this.menuList = nume
    // this.actio = nume[0].path
    // console.log(this.$t('menu'), 88888888888);

this.yj= sessionStorage.getItem('picaetype')||0
    this.defaultActive = window.sessionStorage.getItem('activeMenu')
    this.name = sessionStorage.getItem('userName')
    let a = sessionStorage.getItem('lognum')
    // console.log(111111111111111,a);
    
    if (a == 1) {
      sessionStorage.removeItem('lognum')
      // this.$router.push(nume[0].path)
      // console.log(22222222222222);
      // this.$router.push('/start')
      setTimeout(() => {
        this.$router.push('/start')
        // this.$router.go(0)
        setTimeout(() => {
    
        this.$router.go(0)
    }, 100);
    }, 100);
   
      // console.log(22222222222222);
    }
    // console.log(JSON.parse(sessionStorage.getItem('menuList')));

    this.menuList = nume
  },

  computed: {
    userInitial () {
      const userName = (this.name || '').trim()
      return userName ? userName.charAt(0).toUpperCase() : '?'
    }
  },
  watch: {
    '$route': {
      handler (newVal, old) {
        if (newVal.path == '/order') {
          // sessionStorage.setItem('name', '备件订单')
        } 
        // else if (newVal.path == '/orderDetails'& sessionStorage.getItem('i18n') == 'zh' ) {
        //   sessionStorage.setItem('name', '订单详情')
        //   sessionStorage.setItem('namef', 'Details')
        // } else if (newVal.path == '/sellcontent' && sessionStorage.getItem('i18n') !== 'zh'){
        //   sessionStorage.setItem('name', 'Details')
        //   sessionStorage.setItem('namef', '订单详情')
        // }  else if (newVal.path == '/sellcontent' && sessionStorage.getItem('i18n') == 'zh'){
        //   sessionStorage.setItem('name', '销售注册详情')
        //   sessionStorage.setItem('namef', 'Details')
        // }
        // else if (newVal.path == '/sellcontent' && sessionStorage.getItem('i18n') !== 'zh'){
        //   sessionStorage.setItem('name', 'Details')
        //   sessionStorage.setItem('namef', '销售注册详情')
        // }

        this.titleName = sessionStorage.getItem('name')
          this.biao1()
      },
      immediate: true
    }
  },

  methods: {
    ycl(e){
      this.yj=e
      
      console.log(e);
      
      sessionStorage.setItem('picaetype',e)
      this.$router.go(0)
    },
async biao1 () {
      let param = new URLSearchParams();
      let category = '';
      let type = '';
      let startTime = '';
      let endTime = '';
      let status = '0';
      let searchValue = '';
     
      const { data: res } = await noticetList(
        param,
        status,
        searchValue,
       '',
        1,
        100,
        'desc',
        'id'
      );

      // this.mation = res.rows;
      // this.num = res.summary
      this.totale = res.total;
      console.log(123);
      

    },
    topnum(){
      this.$refs.headd.tophead()
    },
    gotoStart () {
      this.$refs.headd.chlist=[]
      this.$refs.headd.actio=''
      let a =sessionStorage.getItem('i18n')
      if(a=='zh' ){
        sessionStorage.setItem('name','首页')
        sessionStorage.setItem('namef','home')
      }else{
        sessionStorage.setItem('name','home')
        sessionStorage.setItem('namef','首页')
      }
     
      this.$router.push('/start')
    },
    tabEn () {
      this.lange = true
      this.$i18n.locale = 'en'
      sessionStorage.setItem('i18n', 'en')
      let a =sessionStorage.getItem('namef')
      let b =sessionStorage.getItem('name')
      sessionStorage.setItem('name', a)
      sessionStorage.setItem('namef', b)
      //  const language = this.$translate
      //  console.log(123,language);
  //      this.i18nac='en'
    
  //      this.$translate.changeLanguage("english");
      
  // this.$translate.execute(); // 执行翻译
      location.reload()
      this.$router.go(0)
    },
     tabde () {
      // this.lange = true
      this.$i18n.locale = 'de'
      sessionStorage.setItem('i18n', 'de')
      let a =sessionStorage.getItem('namef')
      let b =sessionStorage.getItem('name')
      sessionStorage.setItem('name', a)
      sessionStorage.setItem('namef', b)
       this.i18nac='de'
    
  //      this.$translate.changeLanguage("deutsch");
      
  // this.$translate.execute(); // 执行翻译
      location.reload() 
      this.$router.go(0)
    },
    tabCn () {
      this.lange = false
      this.$i18n.locale = 'zh'
      sessionStorage.setItem('i18n', 'zh')
      let a =sessionStorage.getItem('namef')
      let b =sessionStorage.getItem('name')
      sessionStorage.setItem('name', a)
      sessionStorage.setItem('namef', b)
      location.reload()
      this.$router.go(0)
    },
    goBack () {
      let a = sessionStorage.getItem('namefac1')
      let b = sessionStorage.getItem('namefac2')
      sessionStorage.setItem('name',a )
      sessionStorage.setItem('namef',b )
      this.$router.back()
      // if ()
      //   sessionStorage.setItem('name', '订单详情')
    },
    goPush (url, name) {
      sessionStorage.setItem('name', name)
        this.$refs.headd.chlist=[]
      this.$router.push(url)

 this.titleName = sessionStorage.getItem('name')
    },
    delStyle () {
      const el = document.querySelector('.menu-tab')
      setTimeout(() => {
        el.classList.remove('show')
      }, 1000);
      console.log(el.classList)
    },
    setStyle (index) {
      const el = document.querySelector('.menu-tab')
      console.log(el.classList)
      this.show = index
      el.classList.add('show')
    },
    changeActive (e, item, index) {
      this.menuList[index]['menu'] = true
      console.log(item)
    },
    removeActive (e, item, index) {

    },
    gotoCart (num) {
      this.showMenu = false
      this.$router.push('/shop?active=' + num)
      if (num === 1) {
        this.$router.push('/shop/attachments')
      } else if (num === 2) {
        this.$router.push('/shop/attachment')
      } else {
        this.$router.push('/shop/cart')
      }


    },
    routera (command) {
      console.log(command)
      if (command === 'logout') {
        this.logout()
        return
      }
      if (command == '/my') {
        this.breadcrumb1 = this.name
        this.breadcrumb2 = this.$t('menu.AccountCenter')
      } else {
        this.breadcrumb1 = this.name
        this.breadcrumb2 = this.$t('menu.EmployeeManagement')
      }
      this.$router.push(command)
    },
    // 点击跳转
    tabclick (e, i) {
      if (e.id == 2) {
        this.showMenu = true
      } else {
        this.showMenu = false
      }
      console.log(e)
      if (e.id == 2) {
        return
      }
      this.$router.push(e.path)
      this.breadcrumb1 = e.name.slice(0, 2)
      this.breadcrumb2 = e.name
      this.breadcrumbpath = e.path
    },
    logout () {
      window.sessionStorage.clear()
      this.$store.commit('setMenus', [])
      this.$store.commit('setTreeList', {})
      this.$router.replace('/login').catch(() => {})
    },
    // async getMenuList() {
    // //  const {data: result} =  await this.$http.get('/rights/getRightsList')
    // //  if(result.status !== 200) return this.$message.error("左侧菜单查询失败")
    //  //如果请求正常,则将返回值结果赋值给vue的data
    //  this.menuList = result.data

    // },
    //设定左侧折叠展开效果
    collspseClick () {
      this.isCollapse = !this.isCollapse
    },
    defaultActiveMenu (activeMenu) {
      //为了实现返回之后的选中效果,应该将数据保存到第三方中sessionStory
      window.sessionStorage.setItem('activeMenu', activeMenu)
      this.defaultActive = activeMenu
    },
    vae (e) {
      var c = sessionStorage.getItem('type')

      console.log(e)
      if (c == 1) {
        this.$router.push({
          path: '/certi',
          query: {
            djs: 1,
          },
        })
      }
      if (c == 2) {
        this.$router.push('/certi')
      }
    },
  },
}
</script>

<!-- 防止样式重叠 -->
<style lang="less" scoped>
.ccba {
  font-size: 24px;
}

.ccbac {
  font-size: 20px;
}

.el-header {
  background: linear-gradient(90deg, #fbfcff 0%, #fff 50%, #f9fbff 100%);
  display: flex;
  align-items: stretch;
  color: #202735;
  padding: 0 clamp(24px, 5vw, 72px);
  height: 72px !important;
  width: 100%;
  font-size: 14px;
  border-bottom: 1px solid #edf0f5;
  box-shadow: 0 3px 14px rgba(31, 45, 61, .04);
  margin-bottom: 0;

  .brand-area {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    padding-right: clamp(28px, 4vw, 58px);
  }

  .headerlogo {
    width: 122px;
    max-height: 38px;
    object-fit: contain;
    cursor: pointer;
  }

  .headertab {
    display: flex;
    align-items: center;
    width: 70%;
    cursor: pointer;

    // justify-content: space-around;
    .mr-120 {
      margin-right: 120px;
    }
  }
}

.header-actions {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 22px;
  padding-left: 28px;
  white-space: nowrap;
}

.quick-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.quick-action-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
  transition: transform .2s ease, opacity .2s ease;
}

.quick-action-icon:hover {
  opacity: .75;
  transform: translateY(-1px);
}

.notice-action {
  position: relative;
  color: #768091;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}

.notice-badge {
  position: absolute;
  top: -9px;
  right: -11px;
  min-width: 17px;
  height: 17px;
  padding: 0 4px;
  border: 2px solid #fff;
  border-radius: 9px;
  background: #f5222d;
  color: #fff;
  font-size: 9px;
  line-height: 13px;
  text-align: center;
  box-sizing: border-box;
}

.language-trigger,
.user-trigger {
  display: flex;
  align-items: center;
  color: #303746;
  cursor: pointer;
}

.language-trigger {
  gap: 2px;
  font-size: 13px;
}

.user-trigger {
  gap: 10px;
  font-size: 13px;
}

.user-name {
  max-width: 110px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-avatar {
  width: 27px;
  height: 27px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #c8cdd5;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
}

.user-arrow {
  margin-left: 0;
  color: #8b93a1;
  font-size: 11px;
}


.viewcontent {
  width: 90% !important;

  border-radius: 10px;
  margin: 0 auto;
}

.sales-page-main {
  padding: 0;
  height: calc(100vh - 72px);
  overflow: hidden;
}

.sales-page-main > .viewcontent {
  width: 100% !important;
  margin: 0;
  border-radius: 0;
}

.single-scroll-main {
  overflow: visible;
}

/deep/.el-breadcrumb__inner {
  font-size: 18px;
}

/deep/.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #409eff !important;
  cursor: context-menu;
}

.breadcrumb {
  width: 90% !important;
  margin: 0 auto;
  
  padding-top: 20px;
  font-size: 20px;
  display: flex;
  align-items: center;
  // padding-left: 12px;
}

.el-aside {
  background-color: #2c3e50;

  .el-menu {
    border-right: none;
  }
}
.el-main {
  background-color: #eeeeee;

}

.home-container {
  height: 100%;
  width: 100%;
}

.iconfont {
  margin-right: 8px;
}

//定义折叠项
.leftCollapse {
  //设定背景色
  background-color: #708090;
  //定义字体大小
  font-size: 10px;
  //定义行高
  line-height: 30px;
  //定义颜色
  color: #ffffff;
  //设置居中
  text-align: center;
  //设定字符间距
  letter-spacing: 4px;
  //鼠标放上之后设置为小手
  cursor: pointer;
}
@media (max-width: 1100px) {
  .el-header {
    padding: 0 24px;

    .brand-area {
      padding-right: 22px;
    }

    .headerlogo {
      width: 104px;
    }
  }

  .header-actions {
    gap: 14px;
    padding-left: 16px;
  }

  .quick-actions {
    gap: 14px;
  }
}
.red {
  display: inline-block;
  width: 20px !important;
  height: 20px !important;
  background-color: red !important;
  border-radius: 10px;
  text-align: center;
  line-height: 20px;
  color: #fff !important;
  margin-left: 20px !important;
  position: absolute;
  right: 5px;
  top: 15px;
  z-index: 5;
}

.el-menu-item .is-active {
  position: relative;
}

/deep/.el-submenu__title {
  text-align-last: left !important;
}

.menu-tab {
  position: fixed;
  display: flex;
  background-color: #eee;
  width: 100%;
  padding-left: 480px;
  left: 0;
  margin-bottom: 40px;

  p {
    margin-right: 10px;
  }

  transform: translateY(-400%);
  transition: transform .2s linear .25s;
}

.show {
  // top: 100px !important;
  transform: translateY(50%);
}

.menu-item {
  &:hover {
    color: #fff;
    background-color: #409eff;
  }
}
</style>
